import {TextInput, TouchableOpacity, View, Text} from "react-native";
import React, {useRef, useState} from "react";
import CalendarPicker from 'react-native-calendar-picker';
import {THEME_COLORS} from "../styles";
import moment from "moment";
import {Dropdown} from '../component'

interface IDatePickerProps {
    onDateChange: (value) => void;
    value: string;
    inputStyle: any;
    placeholder: string;
}

export const DatePicker = (props: IDatePickerProps) => {
    const [showPicker, setShowPicker] = useState(false);
    const inputRef = useRef();
    return <>
        <TouchableOpacity
            ref={inputRef}
            onPress={() => setShowPicker(true)}
        >
            {/* <TextInput
                autoFocus={false}
                style={[props.inputStyle]}
                value={!!props.value? props.value: ""}
                disabled={true}
                placeholder={props.placeholder}
                onChangeText={(text) => {
                }}
            /> */}
            <Text style={[props?.inputStyle]}>{props?.value ?? props?.placeholder}</Text>
        </TouchableOpacity>

        <Dropdown show={showPicker} onClose={() => setShowPicker(false)} parentRef={inputRef}>
            <View style={{
                backgroundColor: THEME_COLORS.white, paddingHorizontal: 5,
                borderRadius: 12, shadowColor: THEME_COLORS.shadow2, shadowOpacity: 1, shadowRadius: 4
            }}>
                <CalendarPicker
                    width={300}
                    height={300}
                    selectedDayColor={THEME_COLORS.primary}
                    selectedDayTextColor={THEME_COLORS.white}
                    maxDate={moment.now()}
                    onDateChange={(value) => {
                        props.onDateChange(value);
                        setShowPicker(false);
                    }}
                />
            </View>
        </Dropdown>
    </>
};
